// extracted by mini-css-extract-plugin
export default {"containerText":"Title_containerText__Iuhmt"};